
import { computed, defineComponent, ref, SetupContext } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "BaseCheckbox",
  props: {
    modelValue: { type: [String, Boolean] },
    label: { type: String, required: false },
    trueValue: { default: true },
    falseValue: { default: false },
  },
  setup(props, { emit }: SetupContext) {
    const loading = ref(false);
    const inputValue = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });
    return {
      inputValue,
    };
  },
});
